import type { IAsset } from '../../../../interfaces/asset';
import type { ICustomControlProcedureReadProps } from '../../interfaces/';
import { translateKey } from '../../../../../translate';
import { HeaderDivider } from '../../../../elements/common';
import { FormGroup } from '../../../../elements/forms/FormGroup';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { ProcedureAssetThumbnails } from '../../../episodes/common';
import { RedenenRead } from '../../TCCr/v1/Redenen';

export function TcorV1ProcedureSummary(props: ICustomControlProcedureReadProps) {
    let procedureFiles: IAsset[] = [];
    if (Array.isArray(props.procedure.assets)) {
        procedureFiles = procedureFiles.concat(props.procedure.assets);
    }

    if (props.procedure.customControlData && Array.isArray(props.procedure.customControlData.files)) {
        procedureFiles = procedureFiles.concat(props.procedure.customControlData.files);
    }

    return (
        <>
            {procedureFiles.length > 0 && (
                <FormGroup>
                    <HeaderDivider text={translateKey('procedure.procedure')} />
                    <FormLabel>{translateKey('request.attachment')}: </FormLabel>
                    <ProcedureAssetThumbnails
                        assets={procedureFiles}
                        procedureId={props.procedure.id}
                    />
                </FormGroup>
            )}

            {(props.procedure.customControlData.reden || props.procedure.customControlData.redenen) && (
                <RedenenRead
                    customControlData={{
                        reden: props.procedure.customControlData.reden,
                        redenen: props.procedure.customControlData.redenen,
                    }}
                />
            )}
        </>
    );
}
